const PLACEHOLDER_LOGOS = [
  "AntWalk",
  "RLSS (India)",
  "RahLegal",
  "WLSL",
  "Anunta",
  "Lodha",
  "Rotary District 3141",
  "Vasudev Industries",
  "Axelsys",
  "Batliwala Process Engineering",
  "AntoniaHR",
  "Fiterobic",
];

export default function LogoMarquee() {
  return (
    <div className="marquee overflow-hidden w-full" data-testid="logo-marquee">
      <div className="marquee-track">
        {[...PLACEHOLDER_LOGOS, ...PLACEHOLDER_LOGOS].map((logo, i) => (
          <div
            key={i}
            className="flex items-center justify-center px-10 md:px-16 py-8 border-r border-white/10 min-w-[220px] md:min-w-[260px]"
          >
            <span className="font-playfair text-xl md:text-2xl tracking-[0.2em] text-[#D9D9D9]/60 hover:text-[#D4AF37] transition-colors duration-500 whitespace-nowrap">
              {logo}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
